// providerslice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    "patient_id": '',
    "age": '',

    "alert_title":'',
    "alert_severity":[],
    "alert_description":'',
    "provider_id":'',
    
    "device_id": '',
    "user_id":'',
    "alert_type":'',
    "reading_details":'',
    "organization_id":'',
    "acknowledge_day": '',
    "acknowledge_month": '',
    "acknowledge_year": '',
    "patient_id_inverse": '',
    "age_inverse": '',
    "device_id_inverse": '',
    "alert_type_inverse":'',
    "reading_details_inverse":'',
    "user_id_inverse":'',
    "organization_id_inverse":'',
    "acknowledge_date_inverse": '',

    "alert_title_inverse":'',
    "alert_severity_inverse":'',
    "alert_description_inverse":'',
    "provider_id_inverse":'',

    "match": false,
    "deviceAlertSearchApplied": false,

};

const deviceAlertSearchSlice = createSlice({
    name: 'deviceAlertSearch',
    initialState,
    reducers: {
        setDeviceAlertSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetDeviceAlertSearch(state) {
            return { ...initialState, deviceAlertSearchApplied: false }; // Reset state and flag
        },
        setDeviceAlertSearchApplied(state) {
            state.deviceAlertSearchApplied = true; // Directly set searchApplied to true
        },
    },
});

export const { setDeviceAlertSearch, resetDeviceAlertSearch, setDeviceAlertSearchApplied } = deviceAlertSearchSlice.actions;

export default deviceAlertSearchSlice.reducer;